import React from "react";
import { useCookieConsent } from "../context/CookieConsentContext";
import "../styles/cookies.css";

export default function CookieBanner() {
  const { bannerOpen, setSettingsOpen, acceptAll } = useCookieConsent();

  if (!bannerOpen) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
    >
      <div className="cookie-banner__text">
        <p>
          Usamos cookies en nuestra página web. Al navegar por el sitio
          manifiestas estar de acuerdo con ellas.{" "}
          <a
            href="pdf/legal/aviso-de-privacidad.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Política de privacidad
          </a>
        </p>
      </div>

      <div className="cookie-banner__actions">
        <button
          type="button"
          className="cookie-btn cookie-btn--ghost"
          onClick={() => setSettingsOpen(true)}
        >
          Opciones
        </button>
        <button
          type="button"
          className="cookie-btn cookie-btn--primary"
          onClick={acceptAll}
        >
          Aceptar
        </button>
      </div>
    </div>
  );
}
